import { DeviceForAPI } from 'src/app/services/data/devices-data/devices-data.types';
import { ExportRow } from '@portal/shared/types/export.types';

export const mapSensorToExport = (sensor: DeviceForAPI, formatDate: (date: string) => string): ExportRow =>
  ({
    commDeviceId: {
      title: 'CommDeviceID',
      value: sensor.commDeviceId ?? sensor.parentCommDeviceId ?? ''
    },
    serialNumber: {
      title: 'SerialNumber',
      value: sensor.serialNumber ?? ''
    },
    deviceTypeName: { title: 'DeviceType', value: sensor.deviceTypeName },
    gnnId: {
      title: 'GNNID',
      value: sensor.servicePoints.reduce((acc, item, idx) => {
        const serviceLocationId = item.serviceLocationId ?? '';
        return idx > 0 ? `${acc}\n${serviceLocationId}` : serviceLocationId;
      }, '')
    },
    status: { title: 'Status', value: sensor.status },
    deviceStatusValue: { title: 'DeviceHealth', value: sensor.deviceStatusValue },
    lastHeard: {
      title: 'LastHeard',
      value: sensor.lastHeard ? formatDate(sensor.lastHeard) : ''
    },
    batteryStatus: { title: 'BatteryStatus', value: sensor.batteryStatus },
    validTransmissionReadRateStatus: {
      title: 'ValidReadRateStatus',
      value: sensor.validTransmissionReadRateStatus
    },
    location: [
      { title: 'Latitude', value: sensor.geoMetaData?.latitude ?? '' },
      { title: 'Longitude', value: sensor.geoMetaData?.longitude ?? '' },
      { title: 'Comment', value: sensor.geoMetaData?.comments ?? '' }
    ]
  }) as ExportRow;
